import type { RendererProps } from '@jsonforms/core';
import React from 'react';

export interface JsonFormLayoutProps extends RendererProps {
    children: React.ReactNode;
    className: string;
}

export const JsonFormsLayout = ({ className, children, visible }: JsonFormLayoutProps) => {
    return (
        <div className={className} hidden={!visible}>
            {children}
        </div>
    );
};
